/** Short UI labels for common MIME types (tables, uploads, tooltips). Extend as needed. */
export const MIME_TYPE_SHORT_LABELS: Record<string, string> = {
  'application/pdf': 'PDF',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel',
  'application/vnd.ms-excel': 'Excel',
  'image/jpeg': 'JPEG',
  'image/png': 'PNG',
  'image/gif': 'GIF',
  'text/plain': 'TXT',
  'text/csv': 'CSV',
  'application/zip': 'ZIP',
  'application/msword': 'DOC',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
};

export function formatMimeTypeLabel(mime: string | null | undefined): string {
  if (mime == null || mime === '') {
    return '—';
  }
  return MIME_TYPE_SHORT_LABELS[mime] ?? mime;
}
